import HundredBricksAPIError from '../../HundredBricksAPIError';
class ManagementLogsError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ManagementLogsError', ...args);
    }
}
export default ManagementLogsError;
